import { Link } from 'react-router-dom'
const KnowledgeIcon = () => {
  //   const handleClick = (e) => {
  //     e.preventDefault()
  //     // ir a '/knowledge'
  //     const url = '/knowledge'
  //     window.location = url
  //   }

  return (
    <Link
      className="d-flex justify-content-center align-items-center"
      to="/knowledge"
    >
      <span className="nav-link">
        <i className="fas fa-question"></i>{' '}
      </span>
    </Link>
    // <li
    //   className="d-flex justify-content-center align-items-center"
    //   style={{ cursor: 'pointer' }}
    //   onClick={(e) => {
    //     handleClick(e)
    //   }}
    // >
    //   <span className="nav-link">
    //     <i className="fas fa-question"></i>
    //   </span>
    // </li>
  )
}

export default KnowledgeIcon
